<template>
  <div
    class="px-16 py-8 flex justify-center h-full items-center border-b border-b-neutral-100/10"
  >
    <OButton
      :class="{
        'opacity-60 pointer-events-none': !itemopcao.pode_responder,
        invisible: !itemopcao.pode_ver,
      }"
      :style="{
        background: colorActive,
        color: colorActive ? 'white !important' : null,
      }"
      size="md"
      :label="label"
      class="text-headline-3 w-full OButtonAlternativa transition-colors h-48 !border border-solid !border-neutral-100/10"
      @click="$emit('click:opt')"
    />
  </div>
</template>

<script setup>
import OButton from 'components/Button/OButton.vue'

/** @type {{itemopcao: import('../../types/pergunta').Itemopcaoset}} */
const { itemopcao } = defineProps({
  label: String,
  itemopcao: Object,
  colorActive: String,
})

const emit = defineEmits(['click:opt'])
</script>

<style lang="scss" scoped></style>
